import { useEventSlug } from '@/shared/hooks/useEventSlug'
import { useRecords } from '@/shared/hooks/useRecords'
import type { GamificationPage } from '@/types/gamificationPage'

import { api } from '.'

export async function fetchGamificationPages(eventSlug: string): Promise<GamificationPage[]> {
  const { data } = await api.get<{ records: GamificationPage[] }>(
    `/user/digital_products/${eventSlug}/gamification_pages`
  )
  return data.records ?? []
}

export function useGamificationPages(): ReturnType<typeof useRecords> & { records: GamificationPage[] } {
  const eventSlug = useEventSlug()
  const r = eventSlug ? `/user/digital_products/${eventSlug}/gamification_pages` : ''

  return useRecords({
    r,
    shouldFetch: !!eventSlug,
    options: {
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true
    }
  }) as ReturnType<typeof useRecords> & { records: GamificationPage[] }
}
